import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
  Alert,
  Spinner,
  Badge // ✅ Added Badge import
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { URLS } from "../../Url"
import Select from "react-select"

const Banner = () => {
  const [modal_small, setmodal_small] = useState(false)
  const [banner, setbanner] = useState([])
  const [allBanners, setAllBanners] = useState([])
  const [productname, setproductname] = useState({})
  const [productname1, setproductname1] = useState({})
  const [form, setform] = useState({
    categoryId: "",
    name: "",
    type: "",
    price: "",
    occasionId: "",
    cakeType: "",
    cakePremiumOrNormal: "",
    cakesFilds: false,
    dropdown: false,
    increment: false
  })
  const [form1, setform1] = useState({
    categoryId: "",
    name: "",
    type: "",
    price: "",
    occasionId: "",
    cakeType: "",
    cakePremiumOrNormal: "",
    cakesFilds: false,
    dropdown: false,
    increment: false
  })
  const [show, setshow] = useState(false)
  const [Files, setFiles] = useState("")
  const [Files1, setFiles1] = useState("")
  const [selectedOptions, setSelectedOptions] = useState([])
  const [selectedOptions1, setSelectedOptions1] = useState([])
  const [Occasions, setOccasions] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [fileError, setFileError] = useState("")
  const [fileError1, setFileError1] = useState("")
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [isAllSelected1, setIsAllSelected1] = useState(false)

  // ✅ ADDED: File size limits (30MB as per backend)
  const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff'];
  const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff'];

  const multis = selectedOptions => {
    // Check if "All Occasions" option is selected
    const allOptionSelected = selectedOptions.some(option => option.value === 'all');
    
    if (allOptionSelected) {
      // If "All Occasions" is selected, select all options except the "all" option itself
      const allOptions = options.filter(option => option.value !== 'all');
      setSelectedOptions(allOptions);
      setIsAllSelected(true);
      toast.success("All occasions selected");
    } else {
      setSelectedOptions(selectedOptions);
      setIsAllSelected(selectedOptions.length === options.filter(opt => opt.value !== 'all').length);
    }
  }

  const multis1 = selectedOptions1 => {
    const allOptionSelected = selectedOptions1.some(option => option.value === 'all');
    
    if (allOptionSelected) {
      const allOptions = options.filter(option => option.value !== 'all');
      setSelectedOptions1(allOptions);
      setIsAllSelected1(true);
      toast.success("All occasions selected");
    } else {
      setSelectedOptions1(selectedOptions1);
      setIsAllSelected1(selectedOptions1.length === options.filter(opt => opt.value !== 'all').length);
    }
  }

  // ✅ MODIFIED: Add "All Occasions" option to the beginning
  const options = [
    { value: 'all', label: '🎉 All Occasions (Select All)' },
    ...Occasions.map(response => ({
      value: response._id,
      label: response.name,
    }))
  ];

  // Function to select all occasions
  const selectAllOccasions = () => {
    const allOptions = options.filter(option => option.value !== 'all');
    setSelectedOptions(allOptions);
    setIsAllSelected(true);
    toast.success("All occasions selected");
  }

  // Function to clear all occasions
  const clearAllOccasions = () => {
    setSelectedOptions([]);
    setIsAllSelected(false);
    toast.info("All occasions cleared");
  }

  // Function to select all occasions for edit
  const selectAllOccasions1 = () => {
    const allOptions = options.filter(option => option.value !== 'all');
    setSelectedOptions1(allOptions);
    setIsAllSelected1(true);
    toast.success("All occasions selected");
  }

  // Function to clear all occasions for edit
  const clearAllOccasions1 = () => {
    setSelectedOptions1([]);
    setIsAllSelected1(false);
    toast.info("All occasions cleared");
  }

  useEffect(() => {
    GetOcation()
  }, [])

  const GetOcation = () => {
    var token = datas
    axios
      .post(
        URLS.GetService,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setOccasions(res.data.occasions)
      })
  }

  // ✅ UPDATED: Enhanced file validation
  const changeHandler = e => {
    const file = e.target.files[0];
    setFileError("");
    
    if (!file) {
      e.target.value = null;
      return;
    }

    // Check file type
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const fileType = file.type;
    
    if (!ALLOWED_FILE_TYPES.includes(fileType) || !ALLOWED_EXTENSIONS.includes(fileExtension)) {
      setFileError(`Invalid file type. Allowed: ${ALLOWED_EXTENSIONS.join(', ')}`);
      e.target.value = null;
      toast.error(`Invalid file type. Allowed: ${ALLOWED_EXTENSIONS.join(', ')}`);
      return;
    }

    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      const maxSizeInMB = (MAX_FILE_SIZE / (1024 * 1024)).toFixed(2);
      setFileError(`File size too large (${sizeInMB}MB). Maximum ${maxSizeInMB}MB allowed`);
      e.target.value = null;
      toast.error(`File size too large (${sizeInMB}MB). Maximum ${maxSizeInMB}MB allowed`);
      return;
    }

    // Check image dimensions if needed
    const img = new Image();
    img.onload = function() {
      if (this.width < 100 || this.height < 100) {
        setFileError("Image dimensions too small. Minimum 100x100px required");
        e.target.value = null;
        toast.error("Image dimensions too small. Minimum 100x100px required");
        return;
      }
      
      // All validations passed
      setFiles([file]);
      toast.success("File validated successfully");
    };
    img.src = URL.createObjectURL(file);
  }

  // ✅ UPDATED: Enhanced file validation for edit
  const changeHandler1 = e => {
    const file = e.target.files[0];
    setFileError1("");
    
    if (!file) {
      e.target.value = null;
      return;
    }

    const fileExtension = file.name.split('.').pop().toLowerCase();
    const fileType = file.type;
    
    if (!ALLOWED_FILE_TYPES.includes(fileType) || !ALLOWED_EXTENSIONS.includes(fileExtension)) {
      setFileError1(`Invalid file type. Allowed: ${ALLOWED_EXTENSIONS.join(', ')}`);
      e.target.value = null;
      toast.error(`Invalid file type. Allowed: ${ALLOWED_EXTENSIONS.join(', ')}`);
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      const maxSizeInMB = (MAX_FILE_SIZE / (1024 * 1024)).toFixed(2);
      setFileError1(`File size too large (${sizeInMB}MB). Maximum ${maxSizeInMB}MB allowed`);
      e.target.value = null;
      toast.error(`File size too large (${sizeInMB}MB). Maximum ${maxSizeInMB}MB allowed`);
      return;
    }

    setFiles1([file]);
    toast.success("File validated successfully");
  }

  function tog_small() {
    setmodal_small(!modal_small)
    setFileError1(""); // Clear file error when closing modal
  }

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }
  
  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  useEffect(() => {
    GetAllBanners()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)
  const pagesVisited = pageNumber * listPerPage
  const lists = banner.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(banner.length / listPerPage)
  
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  // ✅ UPDATED: Enhanced form validation before submission
  const handleSubmit = e => {
    e.preventDefault()
    
    // Validate required fields
    if (!form.categoryId) {
      toast.error("Please select a category");
      return;
    }
    
    if (!form.name || form.name.trim().length < 2) {
      toast.error("Product name must be at least 2 characters long");
      return;
    }
    
    if (!Files || Files.length === 0) {
      toast.error("Please select an image");
      return;
    }
    
    if (!form.type) {
      toast.error("Please select product type");
      return;
    }
    
    if (!form.price || parseFloat(form.price) <= 0) {
      toast.error("Please enter a valid price");
      return;
    }
    
    // Validate cake fields if cake category
    if (form.cakesFilds) {
      if (!form.cakeType) {
        toast.error("Please select cake type");
        return;
      }
      if (!form.cakePremiumOrNormal) {
        toast.error("Please select premium type");
        return;
      }
    }
    
    // Validate occasions
    if (selectedOptions.length === 0) {
      toast.error("Please select at least one occasion");
      return;
    }
    
    AddBanner()
  }

  // ✅ UPDATED: Enhanced AddBanner with better error handling
  const AddBanner = () => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    var token = datas;
    
    // Create FormData
    const dataArray = new FormData();
    dataArray.append("categoryId", form.categoryId);
    dataArray.append("name", form.name.trim());
    dataArray.append("type", form.type);
    dataArray.append("price", parseFloat(form.price));
    
    // Add cake fields if applicable
    if (form.cakesFilds) {
      dataArray.append("cakeType", form.cakeType);
      dataArray.append("cakePremiumOrNormal", form.cakePremiumOrNormal);
    } else {
      dataArray.append("cakeType", "");
      dataArray.append("cakePremiumOrNormal", "");
    }

    // Add occasions (filter out the "all" option if present)
    const filteredOccasions = selectedOptions.filter(option => option.value !== 'all');
    dataArray.append("occasionId", JSON.stringify(filteredOccasions));
    
    // Add file
    for (let i = 0; i < Files.length; i++) {
      dataArray.append("image", Files[i]);
    }

    // Show loading
    toast.info("Uploading product...", { autoClose: false, toastId: "uploading" });
    
    axios
      .post(URLS.AddProducts, dataArray, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        timeout: 300000, // 5 minutes timeout for large files
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      })
      .then(res => {
        if (res.status === 200) {
          toast.dismiss("uploading");
          toast.success(res.data.message);
          GetAllBanners();
          clearForm();
          setshow(false);
        }
      })
      .catch(error => {
        toast.dismiss("uploading");
        
        if (error.code === 'ECONNABORTED') {
          toast.error("Request timeout. File might be too large or network is slow");
        } else if (error.response) {
          if (error.response.status === 413) {
            toast.error("File too large. Maximum 30MB allowed");
          } else if (error.response.status === 400) {
            toast.error(error.response.data.message || "Validation error");
          } else if (error.response.status === 401) {
            toast.error("Unauthorized. Please login again");
          } else if (error.response.status === 500) {
            toast.error("Server error. Please try again later");
          } else {
            toast.error(`Error: ${error.response.status} - ${error.response.data.message || "Unknown error"}`);
          }
        } else if (error.request) {
          toast.error("No response from server. Check your network connection");
        } else {
          toast.error(error.message || "Something went wrong");
        }
        console.error("Upload error:", error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  // ✅ UPDATED: Enhanced EditBanner with validation
  const EditBanner = () => {
    if (isEditing) return;
    
    setIsEditing(true);
    var token = datas;
    var formid = form1._id;
    
    // Validate edit form
    if (!form1.categoryId) {
      toast.error("Please select a category");
      setIsEditing(false);
      return;
    }
    
    if (!form1.name || form1.name.trim().length < 2) {
      toast.error("Product name must be at least 2 characters long");
      setIsEditing(false);
      return;
    }
    
    if (!form1.type) {
      toast.error("Please select product type");
      setIsEditing(false);
      return;
    }
    
    if (!form1.price || parseFloat(form1.price) <= 0) {
      toast.error("Please enter a valid price");
      setIsEditing(false);
      return;
    }

    const dataArray = new FormData();
    dataArray.append("categoryId", form1.categoryId);
    dataArray.append("name", form1.name.trim());
    dataArray.append("type", form1.type);
    dataArray.append("price", parseFloat(form1.price));
    
    if (form1.cakesFilds) {
      dataArray.append("cakeType", form1.cakeType);
      dataArray.append("cakePremiumOrNormal", form1.cakePremiumOrNormal);
    } else {
      dataArray.append("cakeType", "");
      dataArray.append("cakePremiumOrNormal", "");
    }

    // Filter out the "all" option if present
    const filteredOccasions1 = selectedOptions1.filter(option => option.value !== 'all');
    dataArray.append("occasionId", JSON.stringify(filteredOccasions1));
    
    // Only append new file if selected
    if (Files1 && Files1.length > 0) {
      for (let i = 0; i < Files1.length; i++) {
        dataArray.append("image", Files1[i]);
      }
    }

    toast.info("Updating product...", { autoClose: false, toastId: "updating" });
    
    axios
      .put(URLS.UpdateProducts + formid, dataArray, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        timeout: 300000
      })
      .then(res => {
        if (res.status === 200) {
          toast.dismiss("updating");
          toast.success(res.data.message);
          GetAllBanners();
          setmodal_small(false);
          clearForm1();
        }
      })
      .catch(error => {
        toast.dismiss("updating");
        
        if (error.response) {
          if (error.response.status === 413) {
            toast.error("File too large. Maximum 30MB allowed");
          } else if (error.response.status === 400) {
            toast.error(error.response.data.message || "Validation error");
          } else {
            toast.error(`Error: ${error.response.status}`);
          }
        } else {
          toast.error(error.message || "Update failed");
        }
        console.error("Update error:", error);
      })
      .finally(() => {
        setIsEditing(false);
      });
  }

  const DeleteBanner = data => {
    var token = datas
    var remid = data._id
    axios
      .delete(URLS.DeleteProducts + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            GetAllBanners()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        }
      )
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to delete this product?")
    if (confirmBox === true) {
      DeleteBanner(data)
    }
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    EditBanner()
  }

  const GetAllBanners = () => {
    var token = datas
    axios
      .post(
        URLS.GetProducts,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setbanner(res.data.products)
        setAllBanners(res.data.products)
      })
  }

  const clearForm1 = () => {
    setFiles1("")
    setform1({
      categoryId: "",
      name: "",
      type: "",
      price: "",
      occasionId: "",
      cakeType: "",
      cakePremiumOrNormal: "",
      cakesFilds: false,
      dropdown: false,
      increment: false
    })
    setSelectedOptions1([])
    setproductname1({})
    setFileError1("")
    setIsAllSelected1(false)
  }

  const clearForm = () => {
    setform({
      categoryId: "",
      name: "",
      type: "",
      price: "",
      occasionId: "",
      cakeType: "",
      cakePremiumOrNormal: "",
      cakesFilds: false,
      dropdown: false,
      increment: false
    })
    setFiles("")
    setSelectedOptions([])
    setproductname({})
    setFileError("")
    setIsAllSelected(false)
  }

  const getpopup = data => {
    const isCakeCategory = data.categoryName === "Cakes" || data.categoryName === "Customisation Cakes"
    setform1({
      ...data,
      cakesFilds: isCakeCategory,
      dropdown: isCakeCategory,
      increment: !isCakeCategory && data.categoryName !== "Roses" && data.categoryName !== "Photography"
    })
    
    // Set selected occasions for edit
    if (data.occasionId && Array.isArray(data.occasionId)) {
      const editOptions = data.occasionId.map(occ => {
        const occasion = Occasions.find(o => o._id === occ.value || o._id === occ._id);
        return occasion ? { value: occasion._id, label: occasion.name } : null;
      }).filter(Boolean);
      
      setSelectedOptions1(editOptions);
      setIsAllSelected1(editOptions.length === Occasions.length);
    } else {
      setSelectedOptions1([]);
      setIsAllSelected1(false);
    }
    
    setproductname1({ name: data.categoryName })
    setFileError1("")
    tog_small()
  }

  const [search, setsearch] = useState([])

  const searchAll = e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    var token = datas
    axios
      .post(
        URLS.GetProductsSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setbanner(res.data.products)
      })
  }
  
  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const [Category, setCategory] = useState([])

  useEffect(() => {
    GetProducts()
  }, [])

  const GetProducts = () => {
    var token = datas
    axios
      .post(
        URLS.GetCategory,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setCategory(res.data.categorys)
      })
  }

  const handleCategoryChange = e => {
    const selectedCategoryId = e.target.value
    const selectedOption = Category.find(
      option => option._id === selectedCategoryId
    )
    
    if (selectedOption) {
      const isCakeCategory = selectedOption.name === "Cakes" || selectedOption.name === "Customisation Cakes"
      const isRosesOrPhotography = selectedOption.name === "Roses" || selectedOption.name === "Photography"
      
      setform(prevForm => ({
        ...prevForm,
        categoryId: selectedCategoryId,
        cakeType: isCakeCategory ? prevForm.cakeType : "",
        cakePremiumOrNormal: isCakeCategory ? prevForm.cakePremiumOrNormal : "",
        cakesFilds: isCakeCategory,
        dropdown: isCakeCategory,
        increment: !isCakeCategory && !isRosesOrPhotography
      }))
      
      setproductname(selectedOption)
    } else {
      setform(prevForm => ({
        ...prevForm,
        categoryId: "",
        cakeType: "",
        cakePremiumOrNormal: "",
        cakesFilds: false,
        dropdown: false,
        increment: false
      }))
      setproductname({})
    }
  }

  const handleCategoryUpdateChange = e => {
    const selectedCategoryId = e.target.value
    const selectedOption = Category.find(
      option => option._id === selectedCategoryId
    )
    
    if (selectedOption) {
      const isCakeCategory = selectedOption.name === "Cakes" || selectedOption.name === "Customisation Cakes"
      const isRosesOrPhotography = selectedOption.name === "Roses" || selectedOption.name === "Photography"
      
      setform1(prevForm => ({
        ...prevForm,
        categoryId: selectedCategoryId,
        cakeType: isCakeCategory ? prevForm.cakeType : "",
        cakePremiumOrNormal: isCakeCategory ? prevForm.cakePremiumOrNormal : "",
        cakesFilds: isCakeCategory,
        dropdown: isCakeCategory,
        increment: !isCakeCategory && !isRosesOrPhotography
      }))
      
      setproductname1(selectedOption)
    } else {
      setform1(prevForm => ({
        ...prevForm,
        categoryId: "",
        cakeType: "",
        cakePremiumOrNormal: "",
        cakesFilds: false,
        dropdown: false,
        increment: false
      }))
      setproductname1({})
    }
  }

  const handleCategoryFilter = e => {
    const selectedCategoryId = e.target.value
    
    if (selectedCategoryId === "") {
      setbanner(allBanners)
    } else {
      const filteredProducts = allBanners.filter(
        product => product.categoryId === selectedCategoryId
      )
      setbanner(filteredProducts)
    }
    setPageNumber(0)
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Carnival Castle Admin"
            breadcrumbItem="Products"
          />
          
          {/* ✅ ADDED: File size warning alert */}
          <Alert color="info" className="mb-3">
            <i className="fas fa-info-circle me-2"></i>
            Maximum file size: 30MB | Allowed formats: JPG, JPEG, PNG, GIF, BMP, TIFF
          </Alert>
          
          <Row>
            {show == true ? (
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-white">
                    <CardTitle>Add Product</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col md="12">
                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <Label for="basicpill-firstname-input1">
                                Occasion Name
                                <span className="text-danger">*</span>
                                {isAllSelected && (
                                  <Badge color="success" className="ms-2">
                                    <i className="fas fa-check-circle me-1"></i>
                                    All Selected
                                  </Badge>
                                )}
                              </Label>
                              <div className="d-flex gap-2">
                                <Button
                                  type="button"
                                  size="sm"
                                  color="primary"
                                  onClick={selectAllOccasions}
                                  outline
                                >
                                  <i className="fas fa-check-double me-1"></i>
                                  Select All
                                </Button>
                                <Button
                                  type="button"
                                  size="sm"
                                  color="secondary"
                                  onClick={clearAllOccasions}
                                  outline
                                >
                                  <i className="fas fa-times me-1"></i>
                                  Clear All
                                </Button>
                              </div>
                            </div>
                            <Select
                              options={options}
                              placeholder="Select occasions or choose 'All Occasions'"
                              value={selectedOptions}
                              onChange={multis}
                              isSearchable={true}
                              isMulti
                              required
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              components={{
                                Option: (props) => {
                                  // Custom option rendering
                                  return (
                                    <div {...props.innerProps} style={props.getStyles('option', props)}>
                                      {props.data.value === 'all' ? (
                                        <div className="fw-bold" style={{ color: '#1890ff' }}>
                                          <i className="fas fa-star me-2"></i>
                                          {props.data.label}
                                        </div>
                                      ) : (
                                        props.data.label
                                      )}
                                    </div>
                                  );
                                }
                              }}
                            />
                            <small className="text-muted">
                              {selectedOptions.length > 0 ? (
                                <span>
                                  <i className="fas fa-check text-success me-1"></i>
                                  {selectedOptions.length} occasion(s) selected
                                  {isAllSelected && " (All occasions)"}
                                </span>
                              ) : (
                                "Select at least one occasion or choose 'All Occasions'"
                              )}
                            </small>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="mb-3">
                            <Label>Category</Label>
                            <span className="text-danger">*</span>
                            <select
                              value={form.categoryId}
                              name="categoryId"
                              required
                              onChange={handleCategoryChange}
                              className="form-select"
                            >
                              <option value="">Select Category</option>
                              {Category.map((data, key) => {
                                return (
                                  <option key={key} value={data._id}>
                                    {data.name}
                                  </option>
                                )
                              })}
                            </select>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              placeholder="Enter Name"
                              required
                              name="name"
                              value={form.name}
                              onChange={handleChange}
                              minLength="2"
                              maxLength="100"
                            />
                          </div>
                        </Col>
                        
                        <Col md={4}>
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Image <span className="text-danger">*</span>
                              <small className="text-muted ms-2">Max 30MB</small>
                            </Label>
                            <Input
                              type="file"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              required
                              name="image"
                              onChange={changeHandler}
                              accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff"
                            />
                            {fileError && (
                              <div className="text-danger small mt-1">
                                <i className="fas fa-exclamation-triangle"></i> {fileError}
                              </div>
                            )}
                            {Files && Files.length > 0 && (
                              <div className="text-success small mt-1">
                                <i className="fas fa-check-circle"></i> File selected: {Files[0].name} ({(Files[0].size/(1024*1024)).toFixed(2)}MB)
                              </div>
                            )}
                          </div>
                        </Col>

                        {form.cakesFilds && (
                          <>
                            <Col md="4">
                              <div className="mb-3">
                                <Label>Cake Type</Label>
                                <span className="text-danger">*</span>
                                <select
                                  value={form.cakeType}
                                  name="cakeType"
                                  required
                                  onChange={e => handleChange(e)}
                                  className="form-select"
                                >
                                  <option value="">Select Cake Type</option>
                                  <option value="egg">Egg</option>
                                  <option value="eggless">Egg Less</option>
                                </select>
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-3">
                                <Label>Is Premium</Label>
                                <span className="text-danger">*</span>
                                <select
                                  value={form.cakePremiumOrNormal}
                                  name="cakePremiumOrNormal"
                                  required
                                  onChange={e => handleChange(e)}
                                  className="form-select"
                                >
                                  <option value="">Select Premium Type</option>
                                  <option value="premium">Premium</option>
                                  <option value="normal">Normal</option>
                                </select>
                              </div>
                            </Col>
                          </>
                        )}

                        <Col md="4">
                          <div className="mb-3">
                            <Label>Type</Label>
                            <span className="text-danger">*</span>
                            <select
                              value={form.type}
                              name="type"
                              required
                              onChange={handleChange}
                              className="form-select"
                            >
                              <option value="">Select Type</option>
                              <option value="quantity">Quantity</option>
                              <option value="grams">Grams</option>
                            </select>
                          </div>
                        </Col>
                        
                        <Col md={4}>
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Price
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              placeholder={form.type === "quantity" ? "Price per piece" : "Price per 500 grams"}
                              required
                              name="price"
                              value={form.price}
                              onChange={handleChange}
                              min="1"
                              step="0.01"
                            />
                            <small className="text-muted">
                              {form.type === "quantity" 
                                ? "Price will be applied per piece" 
                                : "Price will be applied per 500 grams"}
                            </small>
                          </div>
                        </Col>
                        
                        <Col md={12}>
                          <div style={{ float: "right" }}>
                            <Button 
                              color="primary" 
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <Spinner size="sm" className="me-2" />
                                  Uploading...
                                </>
                              ) : (
                                <>
                                  Submit <i className="fas fa-check-circle"></i>
                                </>
                              )}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              ""
            )}
            
            <Col md={12}>
              <Card>
                <CardHeader className="bg-white">
                  <CardTitle>Product List</CardTitle>
                </CardHeader>
                <CardBody>
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                      <div className="d-flex align-items-center gap-3 flex-wrap">
                        {Roles.productsAdd || Roles?.accessAll === true ? (
                          <Button
                            onClick={() => {
                              setshow(!show)
                              clearForm(); // Clear form when showing add form
                            }}
                            color="primary"
                            className="mb-0"
                          >
                            Add Products List <i className="bx bx-plus"></i>
                          </Button>
                        ) : (
                          ""
                        )}
                        
                        <div className="d-flex align-items-center gap-2">
                          <Label className="mb-0 fw-bold">Filter by Category:</Label>
                          <select
                            onChange={handleCategoryFilter}
                            className="form-select"
                            style={{ width: "200px" }}
                          >
                            <option value="">All Categories</option>
                            {Category.map((data, key) => {
                              return (
                                <option key={key} value={data._id}>
                                  {data.name}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      </div>
                      
                      <div style={{ minWidth: "250px" }}>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search products..."
                          value={search.search}
                          onChange={searchAll}
                          name="search"
                        />
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-4">
                        <thead>
                          <tr className="text-center">
                            <th>S.No</th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Category Name</th>
                            <th>Type</th>
                            <th>Cake Type</th>
                            <th>IsPremium</th>
                            <th>Price</th>
                            <th>Occasions</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key} className="text-center">
                              <td>{(pageNumber) * 5 + key + 1}</td>
                              <td>
                                <img
                                  style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                  src={URLS.Base + data.image}
                                  alt={data.name}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "";
                                  }}
                                />
                              </td>
                              <td>{data.name}</td>
                              <td>{data.categoryName}</td>
                              <td>{data.type}</td>
                              <td>{data.cakeType || "N/A"}</td>
                              <td>{data.cakePremiumOrNormal || "N/A"}</td>
                              <td>₹{data.price} /-</td>
                              <td>
                                {data.occasionId && Array.isArray(data.occasionId) ? 
                                  data.occasionId.length > 0 ? 
                                    data.occasionId.length === Occasions.length ? 
                                      "All Occasions" : 
                                      `${data.occasionId.length} occasion(s)` 
                                    : "None"
                                  : "None"}
                              </td>
                              <td>
                                {Roles.productsEdit || Roles?.accessAll === true ? (
                                  <Button
                                    onClick={() => {
                                      getpopup(data)
                                    }}
                                    className="mr-2"
                                    style={{
                                      padding: "6px",
                                      margin: "3px",
                                    }}
                                    color="success"
                                    outline
                                  >
                                    <i className="bx bx-edit "></i>
                                  </Button>
                                ) : (
                                  ""
                                )}
                                {Roles.productsDelete || Roles?.accessAll === true ? (
                                  <Button
                                    onClick={() => {
                                      manageDelete(data)
                                    }}
                                    style={{
                                      padding: "6px",
                                      margin: "3px",
                                    }}
                                    color="danger"
                                    outline
                                  >
                                    <i className="bx bx-trash"></i>
                                  </Button>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      
                      {lists.length === 0 && (
                        <div className="text-center py-4">
                          <i className="fas fa-box-open fa-3x text-muted mb-3"></i>
                          <h5>No products found</h5>
                          <p className="text-muted">Try adding a product or change your search criteria</p>
                        </div>
                      )}
                      
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        
        {/* Edit Modal */}
        <Modal
          size="lg"
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Edit Product
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleSubmit1}>
              <Row>
                <Col md="12">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Label for="basicpill-firstname-input1">
                        Occasion Name
                        <span className="text-danger">*</span>
                        {isAllSelected1 && (
                          <Badge color="success" className="ms-2">
                            <i className="fas fa-check-circle me-1"></i>
                            All Selected
                          </Badge>
                        )}
                      </Label>
                      <div className="d-flex gap-2">
                        <Button
                          type="button"
                          size="sm"
                          color="primary"
                          onClick={selectAllOccasions1}
                          outline
                        >
                          <i className="fas fa-check-double me-1"></i>
                          Select All
                        </Button>
                        <Button
                          type="button"
                          size="sm"
                          color="secondary"
                          onClick={clearAllOccasions1}
                          outline
                        >
                          <i className="fas fa-times me-1"></i>
                          Clear All
                        </Button>
                      </div>
                    </div>
                    <Select
                      options={options}
                      placeholder="Select occasions or choose 'All Occasions'"
                      value={selectedOptions1}
                      onChange={multis1}
                      isSearchable={true}
                      isMulti
                      required
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option: (props) => {
                          return (
                            <div {...props.innerProps} style={props.getStyles('option', props)}>
                              {props.data.value === 'all' ? (
                                <div className="fw-bold" style={{ color: '#1890ff' }}>
                                  <i className="fas fa-star me-2"></i>
                                  {props.data.label}
                                </div>
                              ) : (
                                props.data.label
                              )}
                            </div>
                          );
                        }
                      }}
                    />
                    <small className="text-muted">
                      {selectedOptions1.length > 0 ? (
                        <span>
                          <i className="fas fa-check text-success me-1"></i>
                          {selectedOptions1.length} occasion(s) selected
                          {isAllSelected1 && " (All occasions)"}
                        </span>
                      ) : (
                        "Select at least one occasion or choose 'All Occasions'"
                      )}
                    </small>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder="Enter Name"
                      required
                      name="name"
                      value={form1.name}
                      onChange={handleChange1}
                      minLength="2"
                      maxLength="100"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Image
                      <small className="text-muted ms-2">(Optional) Max 30MB</small>
                    </Label>
                    <Input
                      type="file"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="image"
                      onChange={changeHandler1}
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff"
                    />
                    {fileError1 && (
                      <div className="text-danger small mt-1">
                        <i className="fas fa-exclamation-triangle"></i> {fileError1}
                      </div>
                    )}
                    {form1.image && (
                      <div className="mt-2">
                        <small className="text-muted">Current:</small>
                        <img 
                          src={URLS.Base + form1.image} 
                          alt="Current" 
                          style={{ width: "50px", height: "50px", objectFit: "cover", marginLeft: "10px" }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label>Category</Label>
                    <span className="text-danger">*</span>
                    <select
                      value={form1.categoryId}
                      name="categoryId"
                      required
                      onChange={handleCategoryUpdateChange}
                      className="form-select"
                    >
                      <option value="">Select Category</option>
                      {Category.map((data, key) => {
                        return (
                          <option key={key} value={data._id}>
                            {data.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label>Type</Label>
                    <span className="text-danger">*</span>
                    <select
                      value={form1.type}
                      name="type"
                      required
                      onChange={handleChange1}
                      className="form-select"
                    >
                      <option value="">Select Type</option>
                      <option value="quantity">Quantity</option>
                      <option value="grams">Grams</option>
                    </select>
                  </div>
                </Col>

                {form1.cakesFilds && (
                  <>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Cake Type</Label>
                        <span className="text-danger">*</span>
                        <select
                          value={form1.cakeType}
                          name="cakeType"
                          required
                          onChange={e => handleChange1(e)}
                          className="form-select"
                        >
                          <option value="">Select Cake Type</option>
                          <option value="egg">Egg</option>
                          <option value="eggless">Egg Less</option>
                        </select>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Is Premium</Label>
                        <span className="text-danger">*</span>
                        <select
                          value={form1.cakePremiumOrNormal}
                          name="cakePremiumOrNormal"
                          required
                          onChange={e => handleChange1(e)}
                          className="form-select"
                        >
                          <option value="">Select Premium Type</option>
                          <option value="premium">Premium</option>
                          <option value="normal">Normal</option>
                        </select>
                      </div>
                    </Col>
                  </>
                )}

                <Col md={6}>
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Price
                      <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="number"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      placeholder={form1.type === "quantity" ? "Price per piece" : "Price per 500 grams"}
                      required
                      name="price"
                      value={form1.price}
                      onChange={handleChange1}
                      min="1"
                      step="0.01"
                    />
                  </div>
                </Col>
              </Row>
              <hr></hr>
              <Row>
                <Col md={12}>
                  <div style={{ float: "right" }}>
                    <Button
                      onClick={() => {
                        setmodal_small(false)
                      }}
                      color="danger"
                      type="button"
                    >
                      Cancel <i className="fas fa-times-circle"></i>
                    </Button>
                    <Button 
                      className="m-1" 
                      color="primary" 
                      type="submit"
                      disabled={isEditing}
                    >
                      {isEditing ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Updating...
                        </>
                      ) : (
                        <>
                          Update <i className="fas fa-check-circle"></i>
                        </>
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

export default Banner